import { Link } from 'react-router-dom';
import { useContactsStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { Button } from '@shared/widgets';

export const RecoveryResetUsernameForm = () => {
  const { data } = useContactsStore();

  return (
    <section className='flex flex-col gap-6'>
      <div className='text-center text-sm text-[#fcfcfc] uppercase'>Recover username</div>
      <div className='flex h-[125px] w-full items-center justify-center rounded-sm bg-[#1f1f1f] px-5 shadow-[12px_12px_24px_0_#0000003b]'>
        <p className='text-center text-sm font-medium text-[#929292] uppercase'>
          Please, contact customer service to recover your access using this phone <span className='text-[#fcfcfc]'>{data?.Phone1}</span>
        </p>
      </div>
      <Link to={RoutePaths.recovery.onNavigate()}>
        <Button className='mt-1.5 h-[56px]' fullWidth color='outlined'>
          Cancel
        </Button>
      </Link>
    </section>
  );
};
